import { Navigate } from "react-router-dom";

import { useAuth } from "./authProvider";

const PrivateRoute = ({ element, requiredRole }) => {
  const { token, role: userRole } = useAuth() || {};
  if (!token) {
    return <Navigate to="/" />;
  }

  if (requiredRole && userRole !== requiredRole) {
    return <Navigate to="/" />;
  }

  return element;
};

export default PrivateRoute;

